import CreatePasswordPage from './CreatePasswordPage';
export default CreatePasswordPage;
